/* Colección — Gradivus
   Cargar más sin recargar, y hoja de filtros en mobile. */
(function () {
  function initCargarMas(caja) {
    if (caja.dataset.listo === 'true') return;
    var btn = caja.querySelector('[data-cargar-mas-btn]');
    var vistos = caja.querySelector('[data-vistos]');
    var grid = document.querySelector('.collection-grid__wrapper .grid--uniform');
    if (!btn || !grid) return;

    btn.addEventListener('click', function () {
      var url = caja.dataset.siguiente;
      if (!url) return;

      btn.disabled = true;
      var textoOriginal = btn.textContent;
      btn.textContent = 'Cargando…';

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevos = doc.querySelectorAll('.collection-grid__wrapper .grid--uniform > .grid-product');
          nuevos.forEach(function (el) { grid.appendChild(el); });

          if (vistos) {
            vistos.textContent = grid.querySelectorAll('.grid-product').length;
          }

          var siguiente = doc.querySelector('[data-cargar-mas]');
          caja.dataset.siguiente = siguiente ? siguiente.dataset.siguiente : '';
          btn.disabled = false;
          btn.textContent = textoOriginal;
          if (!caja.dataset.siguiente) btn.hidden = true;

          // la url refleja lo que se esta viendo, para poder compartir o volver
          history.replaceState(null, '', url);
          document.dispatchEvent(new CustomEvent('collection:cargado'));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = textoOriginal;
        });
    });

    caja.dataset.listo = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-cargar-mas]').forEach(initCargarMas);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
